import { createRouter, createWebHistory } from 'vue-router';

//import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

// page
// import Default from '@/module/Home/page/Default.vue';
import Navigate from '@/module/Home/page/Navigate.vue';
import Home from '@/module/Home/page/Home.vue';
import Coupon from '@/module/Coupon/page/Coupon.vue';
import Login from '@/module/Login/page/Login.vue';
import LoginGuest from '@/module/Login/page/LoginGuest.vue';
import LoginPassword from '@/module/Login/page/LoginPassword.vue';
import SetNewPassword from '@/module/Login/page/SetNewPassword.vue';
import ResetPassword from '@/module/ResetPassword/page/ResetPassword.vue';
import Register from '@/module/Register/page/Register.vue';
import RegisterPassword from '@/module/Register/page/RegisterPassword.vue';
import RegisterSuccess from '@/module/Register/page/RegisterSuccess.vue';
import Profile from '@/module/Profile/page/Profile.vue';
import EditProfile from '@/module/Profile/page/EditProfile.vue';
import ChangePassword from '@/module/ChangePassword/page/ChangePassword.vue';
import ResetPasswordEmail from '@/module/ChangePassword/page/ResetPasswordEmail.vue';

import Reward from '@/module/Reward/List/page/Reward.vue';
import RewardDetail from '@/module/Reward/Detail/page/RewardDetail.vue';
import SubscirptionDetail from '@/module/Reward/Detail/page/SubscriptionDetail.vue';

import Subscription from '@/module/Subscription/List/page/Subscription.vue';

import DeliveryMethod from '@/module/DeliveryMethod/page/DeliveryMethod.vue';
import DeliveryAddress from '@/module/Address/DeliveryAddress/page/DeliveryAddress.vue';
import AddAddress from '@/module/Address/DeliveryAddress/page/AddAddress.vue';
import EditAddress from '@/module/Address/DeliveryAddress/page/EditAddress.vue';
import SelectBranch from '@/module/DeliveryMethod/page/SelectBranch.vue';
import Location from '@/module/Address/Location/page/Location.vue';
import AddTaxAddress from '@/module/Address/TaxAddress/page/AddTaxAddress.vue';
import EditTaxAddress from '@/module/Address/TaxAddress/page/EditTaxAddress.vue';
import TaxAddress from '@/module/Address/TaxAddress/page/TaxAddress.vue';

import MyOrder from "@/module/MyOrder/page/MyOrder.vue";
import OrderSummary from '@/module/ShoppingCart/page/OrderSummary.vue';
import OrderPayment from '@/module/ShoppingCart/page/OrderPayment.vue';
import SubscriptionPayment from '@/module/ShoppingCart/page/SubscriptionPayment.vue';

import Complete from '@/module/ShoppingCart/page/Complete.vue';
import SubscriptionComplete from '@/module/ShoppingCart/page/SubscriptionComplete.vue';
import Fail from '@/module/ShoppingCart/page/Fail.vue';
import AddCreditCard from '@/module/CreditCard/page/AddCreditCard.vue';
import CreditDebitCard from '@/module/CreditCard/page/CreditDebitCard.vue';

import crownpoint from '@/module/CrownPoint/page/CrownPoint.vue';
import point from '@/module/CrownPoint/page/Point.vue';
import EarnPoint from '@/module/EarnPoint/page/EarnPoint.vue';
import History from '@/module/History/page/History.vue';

import ProductDetail from "@/module/Product/page/ProductDetail.vue"
import MyFavorite from "@/module/MyFavorite/page/MyFavorite.vue"
import ContactUs from '@/module/Static/ContactUs/page/ContactUs.vue'
import Pdpa from '@/module/Static/Pdpa/page/Pdpa'
import TierLevel from '@/module/TierLevel/page/TierLevel.vue'
import Store from '@/module/Store/page/Store.vue';
import SearchPage from "@/module/List/page/SearchPage.vue";
import MyCoupon from "@/module/MyCoupon/page/MyCoupon.vue";
import Info from '@/module/Info/page/Info.vue'

import Landing from "@/module/Landing/page/Landing.vue";

const routes = [
    {
        path: '/',
        name: 'default',
        component: Navigate
    },
    // template
    {
        path: '/home/:catId?/:subCatId?',
        name: 'home',
        component: Home,
    },
    {
        path: '/coupon',
        name: 'Coupon',
        component: Coupon,
    },
    {
        path: '/contact',
        name: 'ContactUs',
        component: ContactUs,
    },
    {
        path: '/deliverymethod',
        name: 'DeliveryMethod',
        component: DeliveryMethod,
    },
    {
        path: '/selectaddress',
        name: 'SelectAddress',
        component: DeliveryAddress,
    },
    {
        path: '/deliveryaddress',
        name: 'DeliveryAddress',
        component: DeliveryAddress,
    },
    {
        path: '/addaddress',
        name: 'AddAddress',
        component: AddAddress
    },
    {
        path: '/editaddress',
        name: 'EditAddress',
        component: EditAddress
    },
    {
        path: '/addtaxaddress',
        name: 'AddTaxAddress',
        component: AddTaxAddress
    },
    {
        path: '/edittaxaddress',
        name: 'EditTaxAddress',
        component: EditTaxAddress
    },
    {
        path: '/taxaddress',
        name: 'TaxAddress',
        component: TaxAddress
    },
    {
        path: '/selectbranch',
        name: 'SelectBranch',
        component: SelectBranch,
    },
    {
        path: '/location',
        name: 'Location',
        component: Location,
    },
    {
        path: '/ordersummary',
        name: 'OrderSummary',
        component: OrderSummary,
    },
    {
        path: '/orderpayment',
        name: 'OrderPayment',
        component: OrderPayment,
    },
    {
        path: '/subscriptionpayment/:campaignId',
        name: 'SubscriptPayment',
        component: SubscriptionPayment,
    },
    {
        path: '/complete',
        name: 'Complete',
        component: Complete
    },
    {
        path: '/subscriptioncomplete',
        name: 'SubscriptionComplete',
        component: SubscriptionComplete
    },
    {
        path: '/fail',
        name: 'Fail',
        component: Fail
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/loginguest',
        name: 'login_guest',
        component: LoginGuest,
    },
    {
        path: '/login/password',
        name: 'login_password',
        component: LoginPassword,
    },
    {
        path: '/login/setnewpassword',
        name: 'login_setnewpassword',
        component: SetNewPassword,
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
    },
    {
        path: '/register/facebook',
        name: 'register_facebook',
        component: Register,
    },
    {
        path: '/register/google',
        name: 'register_google',
        component: Register,
    },
    {
        path: '/register/password',
        name: 'register_password',
        component: RegisterPassword,
    },
    {
        path: '/register/success',
        name: 'regisger_success',
        component: RegisterSuccess,
    },
    {
        path: '/resetpassword',
        name: 'resetpassword',
        component: ResetPassword,
    },
    {
        path: '/resetpasswordemail',
        name: 'resetpassword_email',
        component: ResetPasswordEmail,
    },
    {
        path: '/changepass',
        name: 'changepass',
        component: ChangePassword,
    },
    {
        path: '/terms',
        name: 'terms',
        component: Pdpa,
    },
    {
        path: '/userlevel',
        name: 'TierLevel',
        component: TierLevel,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Pdpa,
    },
    {
        path: '/addcreditcard',
        name: 'AddCreditCard',
        component: AddCreditCard
    },
    {
        path: '/crownpoint',
        name: 'CrownPoint',
        component: crownpoint
    },
    {
        path: '/point',
        name: 'Point',
        component: point
    },
    {
        path: '/earnpoint',
        name: 'EarnPoint',
        component: EarnPoint
    },
    {
        path: '/history/:tab?',
        name: 'history',
        component: History,
    },
    {
        path: '/card',
        name: 'CreditDebitCard',
        component: CreditDebitCard
    },
    {
        path: '/myorder',
        name: 'MyOrder',
        component: MyOrder
    },
    {
        path: '/reward',
        name: 'reward',
        component: Reward,
    },
    {
        path: '/reward/:campaignId',
        name: 'reward_detail',
        component: RewardDetail,
    },
    
    {
        path: '/subscription/package/:campaignId/:detailkey',
        name: 'subscription_package_detail',
        component: SubscirptionDetail,
    },
    {
        path: '/package/:campaignId',
        name: 'package_detail',
        component: RewardDetail,
    },
    {
        path: '/subscription/:tab?',
        name: 'subscription',
        component: Subscription,
    },
    {
        path: '/subscriptiondetail/:campaignId',
        name: 'subscription_detail',
        component: RewardDetail,
    },
    {
        path: '/notidetail/:campaignId',
        name: 'noti_detail',
        component: RewardDetail,
    },
    {
        path: '/product/:id',
        name: 'product_detail',
        component: ProductDetail
    },
    {
        path: '/favorite',
        name: 'Favorite',
        component: MyFavorite
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
    },
    {
        path: '/profile/edit',
        name: 'profile_edit',
        component: EditProfile,
    },
    {
        path: '/store',
        name: 'Store',
        component: Store,
    },
    {
        path: '/search',
        name: 'search',
        component: SearchPage
    },
    {
        path: '/mycoupon',
        name: 'MyCoupon',
        component: MyCoupon
    },
    {
        path: '/info/:infoPage',
        name: 'Info',
        component: Info,
    },
    {
        path: '/landing/:targetPage',
        name: 'landing',
        component: Landing
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
